<template>
  <div class="clear-btn" @click="clear()"><Icon class="icon" type="ios-nutrition" color="rgb(153, 153, 153)"/>清除条件</div>
</template>

<script>
export default {
  name: 'search-form-item-clear',
  methods: {
    clear () {
      this.$emit('on-clear')
    }
  }
}
</script>

<style lang="less" scoped>
.clear-btn {
  margin-right: 10px;
  margin-left: 0;
  display: inline-block;
  color: rgb(153, 153, 153);
  border-radius: 500px;
  padding: 0 15px;
  font-size: 14px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  user-select: none;

  .icon{
    margin-right: 3px;
  }
}
</style>
